<template lang="pug">
  v-container
    v-row
      v-col(cols="12")
        v-card
          v-card-title
            | Users List
            v-spacer
            v-text-field(v-model="search", append-icon="mdi-magnify", label="Search by First Name, Last Name, Email, Phone", single-line="", hide-details="")
          v-card-text
            v-data-table(:headers="headers", :items="lists", :search="search", item-key="idCustomer")
              template(v-slot:item="{ item }")
                tr(@click="openModal(item)")
                  td {{ item.user.profile && item.user.profile.name ? item.user.profile.name : 'No first name set' }}
                  td {{ item.user.profile && item.user.profile.lastName ? item.user.profile.lastName : 'No last name set' }}
                  td {{ item.user.email }}
                  td {{ item.user.profile && item.user.profile.phone ? item.user.profile.phone : 'No phone set' }}
                  td {{ item.createdAt | moment }}
                  td {{ item.plan && item.plan.name ? item.plan.name : 'No subscription' }}
                  td {{ item.status ? item.status : 'No status set' }}
                  td {{ item.user.profile.restrictions.active ? "Active" : 'No status set' }}

    // Mueve el v-dialog fuera del v-data-table
    v-dialog(v-model="dialog", max-width="600px")
      v-card
        v-card-title
          span.text-h5 Information Details
        v-card-text
          div(v-if="selectedUser && selectedUser.user")
            | Name: {{ selectedUser.user.profile.name }}
            br
            | Last Name: {{ selectedUser.user.profile.lastName }}
            br
            | Email: {{ selectedUser.user.email }}
            br
            | Phone: {{ selectedUser.user.profile.phone }}
            br
            | User ID: {{ selectedUser.user.uid }}
            br
            | Subscription: {{ selectedUser.plan.name }}
            br
            | Subscription ID: {{ selectedUser._id }}
            br
            | Subscription Status: {{ selectedUser.status }}
            br
            | Restrictions:
            ul
              li Active: {{ selectedUser.user.profile.restrictions.active }}
              li Collaborators: {{ selectedUser.user.profile.restrictions.collaborators }}
              li Free Virtual Shop Days: {{ selectedUser.user.profile.restrictions.freeVirtualShopDays }}
              li Sale Points: {{ selectedUser.user.profile.restrictions.salePoints }}
              li Trial Days: {{ selectedUser.user.profile.restrictions.trialDays }}
              li Virtual Shops: {{ selectedUser.user.profile.restrictions.virtualShops }}
            br
            | Created At: {{ selectedUser.user.createdAt | moment }}
        v-card-actions
          v-btn(color="blue darken-1", text, @click="dialog = false") Close
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'UsersListComponent',
    inject: ['theme'],
    filters: {
      moment (date) {
        return moment(date).format('MM-DD-YYYY hh:mm A')
      },
    },
    props: {
      lists: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        search: '',
        dialog: false,
        selectedUser: null, // Inicializado como null
      }
    },
    computed: {
      headers () {
        return [
          { text: 'First Name', value: 'user.profile.name', sortable: true, align: 'left' },
          { text: 'Last Name', value: 'user.profile.lastName', sortable: true, align: 'left' },
          { text: 'Email', value: 'user.email', sortable: true, align: 'left' },
          { text: 'Phone', value: 'user.profile.phone', sortable: true, align: 'left' },
          { text: 'Registration Date', value: 'createdAt', sortable: true, align: 'left' },
          { text: 'Subscription', value: 'plan.name', sortable: true, align: 'left' },
          { text: 'Epayco Status', value: 'status', sortable: true, align: 'left' },
          { text: 'Res. Status', value: 'user.profile.restrictions.active', sortable: true, align: 'left' },
          { text: 'Actions', value: 'actions', sortable: false, align: 'left' },
        ]
      },
    },
    methods: {
      openModal (item) {
        this.selectedUser = item
        this.dialog = true
      },
      replyContact (item) {
        window.location.href = `mailto:${item.user.email}?subject=Contacto del equipo de Tender`
      },
    },
  }
</script>
